<template>
  <div class="admin__home">
    <Header />
    <div class="admin__home--left-div">
      <Sidebar :item="item" />
    </div>
    <div class="admin__home--right-div">
      <div class="benefit">
        <p>
          <span class="benefit__back">
            <routerLink to="/benefits">Benefits</routerLink>
          </span> >
          <span class="benefit__current">Benefits Summary</span>
        </p>
        <div class="benefit__header">
          <div class="benefit__header--text">Benefits Summary</div>
          <div class="benefit__header--edit" @click="showEditBenefit" v-if="manager !== 1">
            <font-awesome-icon icon="edit" />&nbsp;Edit Benefit
          </div>
        </div>

        <div class="benefit__body">
          <div>
            <div class="error" v-show="dataFetchError">
              <p>Unable to fetch benefit data. Please try again.</p>
            </div>
          </div>

          <div class="benefit__div--content-body">
            <div class="benefit__div--content-body-details">
              <div class="benefit__div--content-body-details-left">
                <div>
                  <img src="./../../../assets/style/images/parcel.svg" alt="benefit" />
                </div>
                <p>{{benefit.name}}</p>
              </div>
              <div class="benefit__div--content-body-details-middle">
                <span>More Information About The Benefit</span>
                <p></p>
                <ul>
                  <li>- Worth: ₦{{benefit.worth ? benefit.worth.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : "0.00" }}</li>
                  <li>- Frequency: {{benefit.frequency}}</li>
                </ul>
              </div>
              <div class="benefit__div--content-body-details-right"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <EditBenefit v-if="editBenefit" :benefit="benefit" @closeBenefit="closeEditBenefit" />
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";

import EditBenefit from "./editBenefit";
import * as types from "../../../store/constant";

export default {
  name: "BenefitSummary",
  components: {
    Header,
    Sidebar,
    EditBenefit
  },
  data() {
    return {
      item: "benefit",
      editBenefit: false,
      benefit: {},

      dataFetchError: false,
      manager: 1
    };
  },
  created() {
    this.getBenefit();
    this.getManagerLevel();
  },
  methods: {
    getManagerLevel() {
      if (!this.$store.state.managedClient) {
        const companyId = this.$store.getters.currentAuthUser.employees
          .company_id;
        this.$http.get(`${types.COMPANY_GET_API}/${companyId}`).then(resp => {
          this.$store.state.managedClient = resp.data.data.managed;
          this.manager = this.$store.state.managedClient;
        });
      } else {
        this.manager = this.$store.state.managedClient;
      }
    },
    showEditBenefit() {
      this.editBenefit = true;
    },
    closeEditBenefit(reloadData = false) {
      if (reloadData) {
        this.getBenefit();
      }
      this.editBenefit = false;
    },

    getBenefit() {
      this.$http
        .get(`${types.GET_OTHER_BENEFITS_API}/${this.$route.params.id}`)
        .then(resp => {
          this.benefit = resp.data.data;
        })
        .catch(err => {
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.benefit {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  .error {
    margin-top: 10px;
    margin-bottom: 40px;
    text-align: left;
    color: red;
    font-size: 0.938vw;
    font-style: italic;
    p {
      margin: 0;
      padding-bottom: 10px;
    }
    p::first-letter {
      text-transform: uppercase;
    }
  }

  > p {
    font-size: 0.938vw;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;

    > .benefit__back {
      a {
        color: #5099de;
        text-decoration: none;
      }
    }

    > .benefit__current {
      color: #707070;
    }
  }

  .benefit__header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    align-content: center;

    > .benefit__header--text {
      width: 327px;
      font-size: 2.083vw;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      margin: 0;
    }

    > .benefit__header--edit {
      width: 150px;
      font-size: 1.25vw;
      font-weight: 500;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.25;
      letter-spacing: 0.72px;
      text-align: left;
      color: #5099de;
      text-align: right;
      cursor: pointer;
    }
  }

  > .benefit__body {
    border-top: 1px solid #caced5;
    padding: 0 5px;

    > .benefit__div--content-body {
      > .benefit__div--content-body-details {
        padding: 40px 20px;
        border-radius: 2px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        margin: 50px 0;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: flex-start;
        justify-content: center;
        align-content: center;

        > .benefit__div--content-body-details-left {
          width: 20%;

          > div {
            width: 2.5vw;
          }

          > p {
            text-transform: capitalize;
            font-size: 1.458vw;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.43;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            margin-top: 20px;
          }
        }

        > .benefit__div--content-body-details-middle {
          width: 40%;

          > span {
            font-size: 1.042vw;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 2;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
          }

          > p {
            font-size: 1.042vw;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 2;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            margin: 15px 0;
            max-width: 26.667vw;
          }

          > ul {
            list-style: none;
            padding: 0;

            > li {
              font-size: 1.042vw;
              font-weight: 200;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.2;
              letter-spacing: normal;
              text-align: left;
              color: #f17d6b;
              margin-bottom: 20px;
            }
          }
        }

        > .benefit__div--content-body-details-right {
          width: 40%;
          padding-left: 5.208vw;

          > span {
            font-size: 1.042vw;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 2;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
          }

          > p {
            font-size: 1.042vw;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 2;
            letter-spacing: normal;
            text-align: left;
            color: #000000;
            margin-top: 10px;
          }
        }
      }

      > .benefit__div--content-body-enrol {
        margin-bottom: 50px;
        > p {
          font-size: 1.458vw;
          font-weight: 500;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.43;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }

        .benefit__div--content-body-enrol-filter {
          overflow: hidden;
          > .benefit__div--content-body-filter-left {
            width: 120px;
            height: 35px;
            border-radius: 2px;
            border: solid 1px #caced5;
            background-color: #ffffff;
            float: left;
            margin-right: 20px;
            font-size: 0.833vw;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.19;
            letter-spacing: normal;
            text-align: left;
            color: #777777;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
          }

          > .benefit__div--content-body-filter-right {
            width: 200px;
            height: 35px;
            border-radius: 2px;
            background-color: #ffffff;
            float: left;
          }
        }

        > .benefit__div--content-body-enrol-table {
          margin-top: 30px;
          > .benefit__div--content-body-table-header {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;

            > div {
              width: 33.33333333%;
              text-align: center;
              font-size: 1.042vw;
              font-weight: 500;
              font-style: normal;
              font-stretch: normal;
              line-height: 1;
              letter-spacing: normal;
              color: #000000;
            }
          }

          .benefit__div--content-body-table-body {
            border-top: 5px solid #5099de;
            margin-top: 20px;

            > div {
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              height: 76px;
              margin-bottom: 20px;
              background-color: #ffffff;
              border-radius: 2px;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

              > div {
                width: 33.33333333%;
                text-align: center;
                font-size: 1.042vw;
                font-weight: 500;
                font-style: normal;
                font-stretch: normal;
                line-height: 1;
                letter-spacing: normal;
                color: #000000;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                align-content: center;
              }
            }
          }
        }
      }

      > .benefit__div--content-body-paginate {
        border: 1px solid red;
        width: 20.833vw;
        margin: auto;
        height: 40px;
        border-radius: 4px;
        box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.05);
        border: solid 1px #d7dae2;
        background-color: #ffffff;
        margin-bottom: 150px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;

        > .benefit__div--content-body-paginate-prev {
          width: 20%;
          font-size: 0.781vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: center;
          color: #5099de;
          height: 40px;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;
        }

        > .benefit__div--content-body-paginate-page {
          width: 60%;
          font-size: 0.781vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: center;
          color: #000;
          height: 40px;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;

          > div {
            width: 20%;
            height: 40px;
            border: solid 1px #d7dae2;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
          }
        }

        > .benefit__div--content-body-paginate-next {
          width: 20%;
          font-size: 0.781vw;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: center;
          color: #000;
          height: 40px;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
